// extracted by mini-css-extract-plugin
export default {"section":"section--94Rw5LDlw9","children":"children--FQd5fR817i","title":"title--Y4y-OBubRf"};